import { create } from 'zustand';
import { Marker } from '@citiguide/shared';

export type RouteType = 'walking' | 'driving';

interface MarkerState {
  selectedMarkerId: string | null;
  highlightedMarkerId: string | null;
  visibleMarkers: Marker[];
  /** Route mode currently drawn by RouteCalculator for the selected marker (null = no route). */
  routeType: RouteType | null;
  setSelectedMarker: (markerId: string | null) => void;
  setHighlightedMarker: (markerId: string | null) => void;
  setVisibleMarkers: (markers: Marker[]) => void;
  /** Toggle: asking for the mode already shown clears it (the MarkerModal route buttons). */
  requestRoute: (type: RouteType) => void;
  /** Show a route mode (idempotent, unlike requestRoute). */
  showRoute: (type: RouteType) => void;
  clearRoute: () => void;
}

export const useMarkerStore = create<MarkerState>((set) => ({
  selectedMarkerId: null,
  highlightedMarkerId: null,
  visibleMarkers: [],
  routeType: null,
  setSelectedMarker: (markerId) => set({ selectedMarkerId: markerId }),
  setHighlightedMarker: (markerId) => set({ highlightedMarkerId: markerId }),
  setVisibleMarkers: (markers) => set({ visibleMarkers: markers }),
  requestRoute: (type) => set((state) => ({ routeType: state.routeType === type ? null : type })),
  showRoute: (type) => set({ routeType: type }),
  clearRoute: () => set({ routeType: null }),
}));
